/**
 * Returns bool int value regarding whether page is HRC
 * @returns {Integer} - falsy 0 or truthy
 */
export default function isHRC(testStr) {
    let url = testStr ? testStr.split('?')[0] : window.location.href.split('?')[0];
    return ~url.indexOf('/my/');
}
